
import { Skeleton } from "@/components/ui/skeleton";

export const JobDetailSkeleton = () => {
  return (
    <div className="animate-pulse p-6">
      <div className="h-12 bg-gray-200 rounded mb-6"></div>
      <div className="space-y-4">
        <div className="h-32 bg-gray-200 rounded"></div>
        <div className="h-64 bg-gray-200 rounded"></div>
      </div>
    </div>
  );
};
